import styled from "styled-components";
import { colors } from "../../../../../utils/colors";

export const StripeForm = styled.form`
  min-width: 95vw;
  border: 1px solid whitesmoke;
  padding: 20px 4px;
  margin: 20px 4px;
  background-color: rgba(1, 1, 1, 0.1);
  box-shadow: 0px 0px 10px 0px gray !important;

  @media (min-width: 768px) {
    min-width: 60vw;
  }
`;

export const AmountWrapper = styled.h3`
  margin: 50px auto 25px;
  max-width: 800px;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${colors.BLUE};

  @media (min-width: 768px) {
    min-width: 60vw;
  }
`;

export const Amount = styled.p`
  margin-left: 10px;
  color: ${colors.CREAM}
`;

export const CardWrapper = styled.div`
  margin: 15px auto 25px;
  display: flex;
  gap: 15px;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;
`;

export const Card = styled.img`
  width: 50px;
`;

export const InvoiceInfo = styled.div`
  width: 100%;
  margin: 20px 0;
  color: ${colors.GRAY_DARK};
  text-align: center;
`;